import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { Customer } from '../../../types/types';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-add-contractor',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.scss']
})
export class AddCustomerComponent implements OnInit {

  customer: Customer | undefined = undefined;

  // Set by the caller when adding from the "All Dealer Employees" screen, so the
  // new record is created with the dealer-employee flag on.
  dealerEmployee: boolean = false;

  @Output() contractorEntry: EventEmitter<any> = new EventEmitter();

  form: FormGroup;

  private _message = new Subject<string>();
  
  alertError : boolean = false;

  message : string = '';
  
  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder,private http: HttpClient,private toastrService: ToastrService) { }

  ngOnInit(): void {
    ["id", "name","mobileNumber","mobileNumber2","bankAccountNumber","ifscCode","upiId","verified","createdAt","updatedAt"]
    if( this.customer ){
      this.form = this.fb.group({
        id:this.customer.id,
        name: [this.customer.name],
        mobileNumber: [this.customer.mobileNumber, [Validators.required]],
        mobileNumber2: [this.customer.mobileNumber2, [Validators.required]],
        bankAccountNumber: [this.customer.bankAccountNumber, [Validators.required,Validators.minLength(5), Validators.maxLength(25)]],
        ifscCode: [this.customer.ifscCode, [Validators.required,Validators.minLength(5), Validators.maxLength(20)]],
        upiId: [this.customer.upiId],
        verified: [this.customer.verified],
        internalCode: [this.customer.internalCode],
        state: [this.customer.state],
        district: [this.customer.district],
        type: [this.customer.type],
      });
    }
    else{
      this.form = this.fb.group({
        name: [''],
        mobileNumber: ['', [Validators.required]],
        mobileNumber2: ['', [Validators.required]],
        bankAccountNumber: ['', [Validators.required,Validators.minLength(5), Validators.maxLength(25)]],
        ifscCode: ['', [Validators.required,Validators.minLength(5), Validators.maxLength(20)]],
        upiId: [''],
        verified: [false],
        internalCode: [''],
        state: [''],
        district: [''],
        type: [''],
        dealerEmployee: [this.dealerEmployee],
      });
    }

  }

  onSubmit(){
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    let postUrl = `${environment.serverUrl}/customer`
    if( this.form.value.id != undefined){
      postUrl = `${environment.serverUrl}/customer/${this.form.value.id}`
    }
    
    this.http.post(postUrl, JSON.stringify(this.form.value))
        .subscribe({
          next: (v) => {
            console.log(v)
            this.activeModal.close('Success')
            if( this.form.value.id ){
              this.toastrService.success('Contractor details updated successfully!','Success',{ timeOut: 5000,positionClass: 'toast-top-full-width' });
            }
            else{
              this.toastrService.success('Contractor added successfully!','Success',{ timeOut: 5000,positionClass: 'toast-top-full-width' });
            }

            this.contractorEntry.emit(v);
          },
          error: (e) => {
            console.error(e);
            if( this.form.value.id ){
              this.showMessage("error",`Updating Contractor details failed. Message:${e.message}`);
            }
            else{
              this.showMessage("error",`Adding new Contractor failed. Message:${e.message}`);
            }
          },
          complete: () => console.info('complete')
        });
  }

  showMessage(type, message){
    if( type == "error" ){
      this.alertError = true;
    }
    this._message.next(message);
  }

  numberOnly(event): boolean {   
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
}

}
